import { jsPDF } from "jspdf";
import { clp, num } from "@/lib/api";

export function downloadCertificate({ company, factor, tons, impact }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const code = `TL-${new Date().getFullYear()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
  const date = new Date().toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" });

  doc.setFillColor(10, 31, 24);
  doc.rect(0, 0, 210, 52, "F");
  doc.setTextColor(244, 247, 246);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.text("TERRA", 20, 26);
  doc.setTextColor(0, 242, 161);
  doc.text("LOOP", 52, 26);
  doc.setTextColor(180, 200, 192);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Plataforma de Simbiosis Industrial  ·  terraloop.cl", 20, 36);
  doc.setFontSize(9);
  doc.text(`N° ${code}`, 190, 26, { align: "right" });
  doc.text(date, 190, 32, { align: "right" });

  doc.setTextColor(5, 19, 14);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text("Certificado de Valorización y Mitigación CO₂".replace("₂", "2"), 20, 72);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(60, 80, 72);
  doc.text(`Se certifica que ${company || "la empresa generadora"} ha valorizado el siguiente material`, 20, 82);
  doc.text("mediante la red de simbiosis industrial de terraloop.cl:", 20, 88);

  const rows = [
    ["Material", factor.label],
    ["Cantidad valorizada", `${num(tons, 2)} toneladas`],
    ["CO2 eq. mitigado", `${num(impact.co2, 2)} t CO2e`],
    ["Ahorro estimado en vertedero", clp(impact.landfill)],
    ["Valor como materia prima secundaria", clp(impact.value)],
    ["Equivalencia en árboles (absorción anual)", `${num(impact.trees, 0)} árboles`],
  ];
  let y = 104;
  rows.forEach(([k, v], i) => {
    if (i % 2 === 0) {
      doc.setFillColor(244, 247, 246);
      doc.rect(20, y - 6, 170, 11, "F");
    }
    doc.setTextColor(60, 80, 72);
    doc.text(k, 24, y + 1);
    doc.setTextColor(5, 19, 14);
    doc.setFont("helvetica", "bold");
    doc.text(String(v), 186, y + 1, { align: "right" });
    doc.setFont("helvetica", "normal");
    y += 11;
  });

  doc.setFillColor(0, 242, 161);
  doc.rect(20, y + 6, 170, 1.2, "F");
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 110);
  const note = doc.splitTextToSize(
    "Documento de simulación generado por la Calculadora de Impacto de terraloop.cl. Los valores se basan en factores de emisión y costos referenciales estimados y no constituyen un certificado oficial ni declaración ante la Ley REP. La versión verificada se emite tras la trazabilidad completa del lote (retiro, pesaje y destino final).",
    170
  );
  doc.text(note, 20, y + 16);
  doc.save(`certificado-terraloop-${code}.pdf`);
}


export async function downloadTraceCertificate(tx) {
  const QRCode = (await import("qrcode")).default;
  const m = tx.certificate.metrics;
  const url = `${window.location.origin}/verificar/${tx.code}`;
  const qr = await QRCode.toDataURL(url, { margin: 1, width: 300 });
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const issued = new Date(tx.certificate.issued_at).toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" });

  doc.setFillColor(10, 31, 24);
  doc.rect(0, 0, 210, 44, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(244, 247, 246);
  doc.text("TERRA", 20, 22);
  doc.setTextColor(0, 242, 161);
  doc.text("LOOP", 50.5, 22);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(180, 200, 192);
  doc.text("Certificado de Valorización y Trazabilidad ESG", 20, 32);
  doc.text(`N° ${tx.code}  ·  Emitido ${issued}`, 190, 22, { align: "right" });

  doc.addImage(qr, "PNG", 160, 52, 32, 32);
  doc.setFontSize(7);
  doc.setTextColor(100, 116, 110);
  doc.text("Verificar en línea", 176, 88, { align: "center" });

  doc.setTextColor(5, 19, 14);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text("Certificado de Valorización y Trazabilidad", 20, 60);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(60, 80, 72);
  const intro = doc.splitTextToSize(`Se certifica que el lote "${tx.lot.title}" salió de las instalaciones de ${tx.seller.razon_social || tx.seller.name} y fue recibido e integrado al proceso de ${tx.receipt.tratamiento.toLowerCase()} de ${tx.buyer.razon_social}.`, 132);
  doc.text(intro, 20, 68);

  const rows = [
    ["Generador", `${tx.seller.razon_social || tx.seller.name} · RUT ${tx.seller.rut || "—"}`],
    ["Destinatario / gestor", `${tx.buyer.razon_social} · RUT ${tx.buyer.rut || "—"}`],
    ["ID Establecimiento RETC destino", tx.buyer.retc_id || "—"],
    ["Material", tx.lot.material_tag],
    ["Código LER", tx.lot.ler_code ? `${tx.lot.ler_code} · ${tx.lot.ler_label}` : "—"],
    ["Toneladas valorizadas", `${num(m.tons, 3)} t`],
    ["Tratamiento", tx.receipt.tratamiento],
    ["Fecha de retiro", new Date(tx.pickup.at).toLocaleString("es-CL")],
    ["Fecha de recepción", new Date(tx.receipt.at).toLocaleString("es-CL")],
    ["Documento tributario", `${tx.closing.tipo_documento}${tx.closing.numero ? ` N° ${tx.closing.numero}` : ""}`],
    ["CO2 eq. mitigado", `${num(m.co2_t, 3)} t CO2e`],
    ["Energía evitada", `${num(m.energy_mwh, 1)} MWh`],
    ["Agua evitada", `${num(m.water_m3, 0)} m3`],
    ["Ahorro tasa de portón + flete", clp(m.gate_fee_saved + m.freight_saved)],
    ["Ingreso por venta", clp(m.revenue)],
    ["Válido Ley REP", tx.rep_valid ? "Sí (gestor con declaración vigente)" : "No (receptor sin declaración vigente)"],
  ];
  let y = 96;
  rows.forEach(([k, v], i) => {
    if (i % 2 === 0) {
      doc.setFillColor(244, 247, 246);
      doc.rect(20, y - 5, 170, 8.5, "F");
    }
    doc.setTextColor(60, 80, 72);
    doc.text(k, 23, y);
    doc.setTextColor(5, 19, 14);
    doc.setFont("helvetica", "bold");
    doc.text(String(v).slice(0, 70), 187, y, { align: "right" });
    doc.setFont("helvetica", "normal");
    y += 8.5;
  });
  doc.setFontSize(8);
  doc.setTextColor(100, 116, 110);
  doc.text("Hash de la cadena de custodia (SHA-256):", 20, y + 6);
  doc.setFont("courier", "normal");
  doc.text(tx.certificate.hash, 20, y + 11);
  doc.setFont("helvetica", "normal");
  const note = doc.splitTextToSize(`Verifique la autenticidad en ${url}. Métricas ambientales calculadas con factores referenciales estimados por tipo de material; sujetas a validación por auditoría.`, 170);
  doc.text(note, 20, y + 19);
  doc.save(`certificado-trazabilidad-${tx.code}.pdf`);
}

export async function downloadSinaderSheet(lot, familyName) {
  const QRCode = (await import("qrcode")).default;
  const url = `${window.location.origin}/lotes/${lot.id}`;
  const qr = await QRCode.toDataURL(url, { margin: 1, width: 300 });
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const g = lot.generator || { razon_social: lot.owner_name, rut: "—", vu_code: "—" };
  const folio = `FS-${lot.id.slice(0, 8).toUpperCase()}`;
  const today = new Date().toLocaleDateString("es-CL", { day: "2-digit", month: "long", year: "numeric" });

  doc.setFillColor(10, 31, 24);
  doc.rect(0, 0, 210, 40, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(244, 247, 246);
  doc.text("TERRA", 20, 20);
  doc.setTextColor(0, 242, 161);
  doc.text("LOOP", 47.5, 20);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(180, 200, 192);
  doc.text("Ficha de Caracterización de Residuo · Respaldo declaración SINADER", 20, 30);
  doc.text(`Folio ${folio}  ·  ${today}`, 164, 20, { align: "right" });
  doc.addImage(qr, "PNG", 170, 6, 28, 28);

  let y = 54;
  const section = (title) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(0, 145, 95);
    doc.text(title, 20, y);
    y += 6;
  };
  const rows = (items) => {
    doc.setFontSize(9.5);
    items.forEach(([k, v], i) => {
      const lines = doc.splitTextToSize(String(v ?? "—"), 95);
      const h = Math.max(7.5, lines.length * 4.6 + 3);
      if (i % 2 === 0) {
        doc.setFillColor(244, 247, 246);
        doc.rect(20, y - 4.8, 170, h, "F");
      }
      doc.setFont("helvetica", "normal");
      doc.setTextColor(60, 80, 72);
      doc.text(k, 23, y);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(5, 19, 14);
      doc.text(lines, 187, y, { align: "right" });
      y += h;
    });
    y += 5;
  };

  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.setTextColor(5, 19, 14);
  doc.text("Ficha SINADER del Lote", 20, y - 6);
  y += 4;
  section("1. Identificación del Generador");
  rows([["Razón social", g.razon_social], ["RUT", g.rut], ["Código de establecimiento (Ventanilla Única)", g.vu_code]]);
  section("2. Caracterización del Residuo");
  rows([
    ["Familia", familyName],
    ["Código LER", lot.ler_code],
    ["Descripción LER", lot.ler_label],
    ["Peligrosidad", lot.hazardous ? "Peligroso (declarar en SIDREP)" : "No peligroso"],
    ["Nombre comercial", lot.material_tag],
    ["Estado físico", lot.physical_state],
    ["Cantidad", `${num(lot.weight_tons, 3)} t (${num(lot.weight_tons * 1000, 0)} kg)`],
    ["Método de pesaje", lot.weighed_calibrated ? "Báscula calibrada" : "No declarado"],
  ]);
  section("3. Origen y Retiro");
  rows([["Lugar de retiro", `${lot.comuna}, ${lot.region}`], ["Horario de retiro", lot.pickup_hours], ["Condición de retiro", lot.pickup_note]]);
  section("4. Destino");
  rows([["Destinatario / gestor", "Se completa al adjudicar el lote"], ["Tipo de tratamiento", "Se completa en la recepción en destino"]]);

  doc.setFontSize(8);
  doc.setTextColor(100, 116, 110);
  const note = doc.splitTextToSize(
    `Documento de respaldo generado por terraloop.cl para adjuntar a la declaración en el Sistema Nacional de Declaración de Residuos (SINADER), disponible en la Ventanilla Única del RETC (vu.mma.gob.cl). No reemplaza la declaración oficial, que debe realizar el generador con su código de establecimiento. Ver lote: ${url}`,
    170
  );
  doc.text(note, 20, Math.min(y + 2, 275));
  doc.save(`ficha-sinader-${folio}.pdf`);
}
